import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export class Masks {
    public static readonly PhoneMask = [
        '(',
        new RegExp('[1-9]'),
        new RegExp('\\d'),
        new RegExp('\\d'),
        ')',
        ' ',
        new RegExp('\\d'),
        new RegExp('\\d'),
        new RegExp('\\d'),
        '-',
        new RegExp('\\d'),
        new RegExp('\\d'),
        new RegExp('\\d'),
        new RegExp('\\d')
    ];
    public static readonly CanadianPostalCodeMask = [
        new RegExp('[ABCEGHJKLMNPRSTVXY]', 'i'),
        new RegExp('\\d'),
        new RegExp('[ABCEGHJKLMNPRSTVWXYZ]', 'i'),
        ' ',
        new RegExp('\\d'),
        new RegExp('[BCEGHJKLMNPRSTVWXYZ]', 'i'),
        new RegExp('\\d')
    ];
    public static readonly UsaPostalCodeMask = [
        new RegExp('\\d'),
        new RegExp('\\d'),
        new RegExp('\\d'),
        new RegExp('\\d'),
        new RegExp('\\d')
    ];
    public static readonly CurrencyMask = createNumberMask({
        prefix: '',
        includeThousandsSeparator: true,
        allowDecimal: true,
        decimalLimit: 2
    });
    public static readonly CurrencyMaskWithCents = createNumberMask({
        prefix: '',
        includeThousandsSeparator: true,
        allowDecimal: true,
        decimalLimit: 2,
        requireDecimal: true
    });
    public static readonly HbpsAsPercentMask = createNumberMask({
        prefix: '',
        allowDecimal: true,
        decimalLimit: 4,
        requireDecimal: true
    });
    public static readonly BpsAsPercentMask = createNumberMask({
        prefix: '',
        allowDecimal: true,
        decimalLimit: 2,
        requireDecimal: true
    });
    public static readonly EinMask = [
        new RegExp('[0-9]'),
        new RegExp('[0-9]'),
        '-',
        new RegExp('[0-9]'),
        new RegExp('[0-9]'),
        new RegExp('[0-9]'),
        new RegExp('[0-9]'),
        new RegExp('[0-9]'),
        new RegExp('[0-9]'),
        new RegExp('[0-9]')
    ];

    public static DigitsOnlyMask(length: number): RegExp[] {
        const mask = [];
        for (let i = 0; i < length; i++) {
            mask.push(new RegExp('\\d'));
        }
        return mask;
    }

    public static DateMask(rawValue: any): any[] {
        const monthRegex = [
            new RegExp('[0-1]'),
            rawValue && +rawValue[0] === 1 ? new RegExp('[0-2]') : new RegExp('[0-9]')
        ];
        const yearsRegex = [
            new RegExp('[0-9]'),
            new RegExp('[0-9]'),
            new RegExp('[0-9]'),
            new RegExp('[0-9]')
        ];
        let daysRegex = [new RegExp('[0-9]'), new RegExp('[0-9]')];
        if (rawValue.length >= 2) {
            const month = +rawValue.substr(0, 2);
            const monthsWithThirtyOneDays = [1, 3, 5, 7, 8, 10, 12];
            const february = 2;
            if (month === february) {
                daysRegex = [new RegExp('[0-2]'), new RegExp('[0-9]')];
            } else {
                if (monthsWithThirtyOneDays.indexOf(month) >= 0) {
                    daysRegex = [
                        new RegExp('[0-3]'),
                        +rawValue[3] === 3 ? new RegExp('[0-1]') : new RegExp('[0-9]')
                    ];
                } else {
                    daysRegex = [
                        new RegExp('[0-3]'),
                        +rawValue[3] === 3 ? new RegExp('[0-0]') : new RegExp('[0-9]')
                    ];
                }
            }
        }
        if (rawValue) {
            return [...monthRegex, '/', ...daysRegex, '/', ...yearsRegex];
        } else {
            return [];
        }
    }
}

export class Unmasks {
    public static readonly PhoneUnmask = new RegExp('\\D+', 'g');
    public static readonly CanadaPostalCodeUnmask = new RegExp('\\s+', 'g');
    public static readonly CurrencyUnmask = new RegExp(',', 'g');
    public static readonly EinUnMask = new RegExp('\\D+', 'g');
}
